import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let block = document.querySelector('.highlighted-points');

if(block) {

// Set initial states
    gsap.set('.point-item', {autoAlpha: 0, y: -50});
    gsap.set('.point-item > *', {autoAlpha: 0, y: -15});

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.points',
            start: 'top 90%',
        }
    });

    tl.to('.point-item', {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.1,
        ease: 'power2.out'
    });

    tl.to('.point-item > *', {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.05,
        ease: 'power2.out'
    }, '-=0.3');
}